var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"dropdown-select",attrs:{"solo":"","dense":"","flat":"","items":_vm.data,"label":_vm.label},on:{"change":_vm.setFilter},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }